import { createSlice } from '@reduxjs/toolkit';
import { FilterMatchMode } from 'primereact/api';

import {
  countOfIncomingSmsSlice,
  countOfIncomingSmSSliceFilter,
  countOfIncomingSmsTableFilters,
} from '../../components/Admin/TennantBilling/interface/tenantBilling.interface';

const INITIAL_FILTERS: countOfIncomingSmsTableFilters = {
  client_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  year: { value: null, matchMode: FilterMatchMode.CONTAINS },
  month: { value: null, matchMode: FilterMatchMode.CONTAINS },
  group_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

const incomingSmsFiltersSlice = createSlice({
  name: 'incomingSmsFilters',
  initialState: INITIAL_FILTERS,
  reducers: {
    updateIncomingSmsFilter(state, { payload }: countOfIncomingSmsSlice) {
      const { field, value, matchMode } = payload;

      state[field] = {
        value,
        matchMode,
      };
    },

    setAllFilters(_, { payload }: countOfIncomingSmSSliceFilter) {
      return payload;
    },

    clearFilters() {
      return INITIAL_FILTERS;
    },
  },
});

export const { updateIncomingSmsFilter, setAllFilters, clearFilters } =
  incomingSmsFiltersSlice.actions;

export const incomingSmsFiltersReducer = incomingSmsFiltersSlice.reducer;
